import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { league } from "../../redux/actions";

function useLeagueListingFunctions({ isFilterApplied }) {
  const dispatch = useDispatch();

  const getClassicPrivateLeagues = useCallback(
    (guid, optType, filterIds, filterValues) => {
      dispatch(
        league.fetchUserClassicPrivateLeagues({
          guid,
          optType,
          filterIds,
          filterValues,
        })
      );
    },
    [dispatch]
  );

  const getMiniLeagues = useCallback(
    (guid, optType, filterIds, filterValues) => {
      dispatch(
        league.fetchViewAllMiniLeagues({
          guid,
          optType,
          filterIds,
          filterValues,
        })
      );
    },
    [dispatch]
  );

  const getH2HLeagues = useCallback(
    (guid, optType, filterIds, filterValues) => {
      dispatch(
        league.fetchUserH2HPrivateLeagues({
          guid,
          optType,
          filterIds,
          filterValues,
        })
      );
    },
    [dispatch]
  );

  const getVIPPrivateLeagues = useCallback(
    (guid, optType, filterIds, filterValues) => {
      dispatch(
        league.fetchUserVIPPrivateLeagues({
          guid,
          optType,
          filterIds,
          filterValues,
        })
      );
    },
    [dispatch]
  );

  const getUserPublicLeagues = (guid, optType) => {
    dispatch(
      league.fetchUserStarterPublicLeagues({
        guid,
        opttype: optType,
      })
    );
  };

  const getClassicPublicLeagues = useCallback(
    (guid, pageNo, topNo, filterIds, filtervalue) => {
      if (isFilterApplied && (!!filterIds || !!filtervalue)) {
        dispatch(
          league.fetchUserPublicLeagues({
            guid,
            opttype: 2,
            pageNo,
            topNo,
            filterIds,
            filtervalue,
          })
        );
      } else {
        dispatch(
          league.fetchUserPublicLeagues({
            guid,
            opttype: 1,
            pageNo,
            topNo,
            filterIds: 0,
            filtervalue: 0,
          })
        );
      }
    },
    [dispatch, isFilterApplied]
  );

  return {
    getClassicPrivateLeagues,
    getMiniLeagues,
    getH2HLeagues,
    getVIPPrivateLeagues,
    getUserPublicLeagues,
    getClassicPublicLeagues,
  };
}

export default useLeagueListingFunctions;
